export default __webpack_public_path__ + "static/media/6.20e2b88a.png";